module.exports = __webpack_public_path__ + "images/icons_v2/metric-filled-e821c852.svg";